// https://github.com/fabricjs/fabric.js/blob/master/src/mixins/default_controls.js

export default () => {
  fabric.Object.prototype.set({
    transparentCorners: false,
    borderColor: '#6ccfff',
    cornerColor: '#ffffff',
    cornerStrokeColor: '#c0c5cf',
    cornerStyle: 'circle',
    borderScaleFactor: 2,
  });

  // console.log('controller', fabric.Object.prototype.controls);
  fabric.Object.prototype.controls.mtr.y = 0.5;
  fabric.Object.prototype.controls.mtr.offsetY = 20;

  const { controlsUtils } = fabric;
  fabric.Object.prototype.controls.mtr = new fabric.Control({
    x: 0,
    y: 0.5,
    withConnection: true,
    offsetY: 40,
    actionHandler: controlsUtils.rotationWithSnapping,
    cursorStyleHandler: controlsUtils.rotationStyleHandler,
    actionName: 'rotate',
  });
};
